// src/components/RupiahInput.jsx
//
// Text input for a Rupiah amount: shows grouped-thousands digits with a
// fixed "Rp" prefix as the user types (e.g. "1.500.000"), so a price is
// never ambiguous the way a bare <input type="number"> is. `value`/`onChange`
// carry the plain integer as a string (e.g. "1500000"), same shape every
// harga_satuan/nominal field in Administrasi already used before this
// component existed — so call sites don't need to change their state or
// submit logic, only swap the input element.
import { formatRibuan, parseRupiahInput } from "../utils/currency";

export default function RupiahInput({ value, onChange, className = "", placeholder, disabled }) {
  return (
    <div className="relative">
      <span className="absolute left-3 top-1/2 -translate-y-1/2 text-sm text-muted pointer-events-none">
        Rp
      </span>
      <input
        type="text"
        inputMode="numeric"
        value={formatRibuan(value)}
        disabled={disabled}
        onChange={(e) => onChange(String(parseRupiahInput(e.target.value)))}
        placeholder={placeholder}
        className={`w-full rounded-md border border-white/50 dark:border-white/15 pl-9 pr-3 py-2 text-sm disabled:opacity-60 disabled:bg-black/5 dark:disabled:bg-white/5 ${className}`}
      />
    </div>
  );
}
